export const SCRATCH_CODE_LENGTH = 6;

export enum ScratchErrors {
  CODE_INVALID = 'scratch_card_code_invalid',
  CODE_BLOCKED = 'scratch_card_code_is_block',
}
